import React from "react";
import { Box, Spinner } from "@origin-digital/ods-core";

export const BoxedSpinner = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    marginY="medium"
  >
    <Spinner />
  </Box>
);
